module.exports = __webpack_public_path__ + "img/business_24.2e0f3c97.jpg";